import { Instance } from 'mobx-state-tree'
import { CanPlayThreeCardDailyGameModelBase } from './CanPlayThreeCardDailyGameModel.base'

/* The TypeScript type of an instance of CanPlayThreeCardDailyGameModel */
export interface CanPlayThreeCardDailyGameModelType extends Instance<typeof CanPlayThreeCardDailyGameModel.Type> {}

/* A graphql query fragment builders for CanPlayThreeCardDailyGameModel */
export {
  selectFromCanPlayThreeCardDailyGame,
  canPlayThreeCardDailyGameModelPrimitives,
  CanPlayThreeCardDailyGameModelSelector
} from './CanPlayThreeCardDailyGameModel.base'

/**
 * CanPlayThreeCardDailyGameModel
 */
export const CanPlayThreeCardDailyGameModel = CanPlayThreeCardDailyGameModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
